import { v4 } from 'uuid';
import type { IMarketingKeys } from '../../interfaces/IMarketingKeys';

let cachedPromise: Promise<IMarketingKeys>;

export const getMarketingKeys = (): Promise<IMarketingKeys> => {
  if (cachedPromise) {
    return cachedPromise;
  }
  cachedPromise = new Promise((resolve) => {
    if (window.ltanalytics?.getTrackProperties) {
      const { ClickSessionId } = window.ltanalytics.getTrackProperties();
      resolve({ ClickSessionId });
      return;
    }

    resolve({ ClickSessionId: v4() });
  });

  return cachedPromise;
};

export const getCarpentryIcid = (elem: HTMLElement): string => {
  return `carp-${elem.tagName.toLowerCase()}`;
};
